import React from 'react'
import './badges.sass'

const NumericBadge: React.FC<{ value: number }> = ({ value }) => {
    return <div className="numeric-badge">{value < 99 ? value : '+99'}</div>
}

export default NumericBadge
